import React from 'react'
import Hero from '../Components/Hero'
import Cards from '../Components/Cards'
import AboutShort from '../Components/AboutShort'
import Services from '../Components/Services'
import Service2 from '../Components/Service2'
import Workflow from '../Components/Workflow'
import WhyChooseUs from '../Components/WhyChooseUs'
import Brand from '../Components/Brand'
import ContactInfo from '../Components/ContactInfo'

function Home () {
  return (
    <>
    <div id='loading' className='loader'>
        <img src="/assets/img/loading/fadein-white.gif"/>
      </div>
      <Hero/>
      <Cards/>
      <AboutShort/>
      <Services/>
      <Workflow/>
      <WhyChooseUs/>
      <Brand/>
      <ContactInfo/>
    </>
  )
}

export default Home
